import { PanInfo } from "framer-motion";
import {
  useEffect,
  useRef,
  ReactNode,
  Dispatch,
  SetStateAction,
  useMemo,
} from "react";
import { AnimatePresence, motion, useAnimation } from "framer-motion";
import styles from "./leaflet.module.css";

export default function Leaflet({
  setShow,
  children,
}: {
  setShow: Dispatch<SetStateAction<boolean>>;
  children: ReactNode;
}) {
  const leafletRef = useRef<HTMLDivElement>(null);
  const controls = useAnimation();
  const transitionProps = useMemo(
    () => ({ type: "spring", stiffness: 500, damping: 30 }),
    [],
  );
  useEffect(() => {
    controls.start({
      y: 20,
      transition: transitionProps,
    });
  }, [controls, transitionProps]);

  async function handleDragEnd(
    _: MouseEvent | TouchEvent | PointerEvent,
    info: PanInfo,
  ) {
    const offset = info.offset.y;
    const velocity = info.velocity.y;
    const height = leafletRef.current?.getBoundingClientRect().height || 0;
    if (offset > height / 2 || velocity > 800) {
      await controls.start({ y: "100%", transition: transitionProps });
      setShow(false);
    } else {
      controls.start({ y: 0, transition: transitionProps });
    }
  }

  return (
    <AnimatePresence>
      <motion.div
        ref={leafletRef}
        key='leaflet'
        className={styles.leaflet}
        initial={{ y: "100%" }}
        animate={controls}
        exit={{ y: "100%" }}
        transition={transitionProps}
        drag='y'
        dragDirectionLock
        onDragEnd={handleDragEnd}
        dragElastic={{ top: 0, bottom: 1 }}
        dragConstraints={{ top: 0, bottom: 0 }}
      >
        <div className={styles.handle}>
          <div className={styles.handleBar} />
          <div className={styles.handleBar} />
        </div>
        {children}
      </motion.div>
      <motion.div
        key='leaflet-backdrop'
        className={styles.backdrop}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={() => setShow(false)}
      />
    </AnimatePresence>
  );
}
